// module_configs/fabrics.js
import React from 'react';
import { 
  faGaugeHigh, faUsers, faUserPlus, faUsersLine, faBuilding, faUserTie,
  faBuildingUser, faUserGroup, faIdCard, faListAlt, faShoppingCart,
  faTruckFast, faCartPlus, faFileInvoice, faReceipt, faArrowRotateLeft,
  faRotateLeft, faListCheck, faQrcode, faPrint, faCartShopping, faClipboardList,
  faArrowRightArrowLeft, faMoneyBillWave, faPlus, faGear, faBullhorn,faBoxOpen,
  faLayerGroup, faBoxes, faCog, faPersonHalfDress, faTruck, faHandshake,
  faWarehouse, faSellcast, faBackward, faPerson, faPeopleArrows, faWallet,
  faHistory, faShoppingBag, faUsersCog, faTachometerAlt
} from '@fortawesome/free-solid-svg-icons';

// Import Fabrics components
import DashboardHome from '.././module_fabrics/FabsEasyAnalytics';

import AddCustomer from '.././module_fabrics/customer';

import CustomersListjsx from '.././module_fabrics/customer_list';

import AddSupplier from '.././module_fabrics/Supplier';

import SupplierList from '.././module_fabrics/SuppliersList';

import Partners from '.././module_fabrics/partner';

import PartnerList from '.././module_fabrics/Partnerlist';

import AddFabProduct from '.././module_fabrics/FabProduct';

import FabProductsList from '.././module_fabrics/FabProductsList';

import FabPlaceOrder from '.././module_fabrics/Fab_Placeorder';

import PlaceorderList from '.././module_fabrics/Fab_PlaceorderList';

import FetchFabOrder from '.././module_fabrics/Fab_FetchPlaceorderList';

import Field_Orders from '.././module_fabrics/FieldOrders';

import FieldOrdersList from '.././module_fabrics/FieldOrdersList';

import UsedProducts from '.././module_fabrics/UsedProducts';

import UsedProductsList from '.././module_fabrics/UsedProductsList';

import PosOrderForm from '.././module_fabrics/PosFieldOrder';

import PosOrderList from '.././module_fabrics/PosOrderList';

import Sell from '.././module_fabrics/Sell';

import SellList from '.././module_fabrics/SellList';

import Fab_Sale from '.././module_fabrics/fab_sale';

import FabSaleList from '.././module_fabrics/Fab_SaleList';

import FabReturn from '.././module_fabrics/FabReturn';

import FabReturnList from '.././module_fabrics/Fab_ReturnList';

import Return from '.././module_fabrics/Return';

import AddEmployee from '.././module_fabrics/Employee';

import EmployeeList from '.././module_fabrics/EmployeeList';

import AddSalary from '.././module_fabrics/AddSalary';

import SalaryList from '.././module_fabrics/SalaryList';

import AddCheques from '.././module_fabrics/Cheque';

import ChequeList from '.././module_fabrics/ChequeList';

import UnifiedTransactionForm from '.././module_fabrics/UnifiedTransactionForm';

import FabsTransactionsStatement from '.././module_fabrics/Fab_TransactionsHistory';

import PaidTransactionsList from '.././module_fabrics/fabPaidTransactionslist';

import UnpaidTransactionsList from '.././module_fabrics/UnpaidTransaction';

import AddContainers from '.././module_fabrics/containers';

import ContainerList from '.././module_fabrics/Containerlist';

import ContainerPriceCalculation from '.././module_fabrics/Container_Prices';

import AddFabGodown from '.././module_fabrics/AddGodown';

import FabGodownList from '.././module_fabrics/Godownlist';

import RootUsers from '.././module_roots/RootUsers';

import MessageSystem from '.././module_roots/MessageSystem';

export const fabricsConfig = {
  moduleId: 'fabrics',
  moduleName: 'Fabrics',
  icon: faPersonHalfDress,
  description: 'Fabrics & Tailor Shop Management System',
  
  dashboardComponent: DashboardHome,
  
  roles: {
    'admin_fabrics': { level: 1, label: 'Admin', color: '#8b5cf6' },
    'manager_fabrics': { level: 2, label: 'Manager', color: '#7c3aed' },
    'user_fabrics': { level: 3, label: 'User', color: '#6d28d9' },
    'viewer_fabrics': { level: 4, label: 'Viewer', color: '#5b21b6' }
  },
  
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'inventory', name: 'Inventory & Stock', icon: faBoxes, order: 2 },
    { id: 'sales', name: 'Sales & Transactions', icon: faMoneyBillWave, order: 3 },
    { id: 'system', name: 'System Settings', icon: faCog, order: 4 }
  ],
  
  menus: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faTachometerAlt,
      component: DashboardHome,
      roles: ['all'],
      groupId: 'management',
      position: 0
    },
    {
      id: 'containers',
      label: 'Container',
      icon: faShoppingBag,
      roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics'],
      groupId: 'management',
      position: 1,
      submenus: [
        {
          id: 'addcontainer',
          label: 'Add Container',
          component: AddContainers,
          icon: faShoppingCart,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        },
        {
          id: 'containerslist',
          label: 'Containers List',
          component: ContainerList,
          icon: faShoppingCart,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        },
        {
          id: 'containerspricecalculation',
          label: 'Container Pricing',
          component: ContainerPriceCalculation,
          icon: faShoppingCart,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        }
      ]
    },
    {
      id: 'suppliers',
      label: 'Suppliers',
      icon: faTruck,
      roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics'],
      groupId: 'management',
      position: 2,
      submenus: [
        {
          id: 'addsupplier',
          label: 'Add Supplier',
          component: AddSupplier,
          icon: faUserPlus,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        },
        {
          id: 'supplierlist',
          label: 'Supplier List',
          component: SupplierList,
          icon: faTruck,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        }
      ]
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: faPersonHalfDress,
      roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics'],
      groupId: 'management',
      position: 3,
      submenus: [
        {
          id: 'addcustomer',
          label: 'Add Customer',
          component: AddCustomer,
          icon: faUserPlus,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        },
        {
          id: 'customerlist',
          label: 'Customer List',
          component: CustomersListjsx,
          icon: faUsers,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        }
      ]
    },
    {
      id: 'godown',
      label: 'Godown',
      icon: faWarehouse,
      roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics'],
      groupId: 'inventory',
      position: 4,
      submenus: [
        {
          id: 'addgodown',
          label: 'Add Godown',
          component: AddFabGodown,
          icon: faWarehouse,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        },
        {
          id: 'godownlists',
          label: 'Godown List',
          component: FabGodownList,
          icon: faListAlt,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        }
      ]
    },
    {
      id: 'partners',
      label: 'Partners',
      icon: faHandshake,
      roles: ['admin_fabrics', 'manager_fabrics'],
      groupId: 'management',
      position: 5,
      submenus: [
        {
          id: 'Partner',
          label: 'Add Partner',
          component: Partners,
          icon: faUserPlus,
          roles: ['admin_fabrics', 'manager_fabrics']
        },
        {
          id: 'PartnerList',
          label: 'Partners List',
          component: PartnerList,
          icon: faHandshake,
          roles: ['admin_fabrics', 'manager_fabrics']
        }
      ]
    },
    {
      id: 'products_fabrics',
      label: 'Products',
      icon: faBoxes,
      roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics'],
      groupId: 'inventory',
      position: 6,
      submenus: [
        {
          id: 'addproduct_fabrics',
          label: 'Add Product',
          component: AddFabProduct,
          icon: faBoxOpen,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        },
        {
          id: 'productslist_fabrics',
          label: 'Products List',
          component: FabProductsList,
          icon: faListAlt,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        }
      ]
    },
    {
      id: 'orders',
      label: 'Place Orders',
      icon: faShoppingBag,
      roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics'],
      groupId: 'sales',
      position: 7,
      submenus: [
        {
          id: 'fabplaceorder',
          label: 'Place Order',
          component: FabPlaceOrder,
          icon: faShoppingCart,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        },
        {
          id: 'orderslist',
          label: 'Orders List',
          component: PlaceorderList,
          icon: faShoppingCart,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        },
        {
          id: 'fetchfaborder',
          label: 'Fetch Order',
          component: FetchFabOrder,
          icon: faShoppingCart,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        }
      ]
    },
    {
      id: 'fieldorders',
      label: 'Field Orders',
      icon: faTruck,
      roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics'],
      groupId: 'sales',
      position: 8,
      submenus: [
        {
          id: 'fieldorder',
          label: 'Take Order',
          component: Field_Orders,
          icon: faShoppingCart,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        },
        {
          id: 'fieldorderlist',
          label: 'Field Order List',
          component: FieldOrdersList,
          icon: faShoppingCart,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        }
      ]
    },
    {
      id: 'sale_fabrics',
      label: 'Sale',
      icon: faCartShopping,
      roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics'],
      groupId: 'sales',
      position: 9,
      submenus: [
        {
          id: 'addsale_fabrics',
          label: 'Add Sale',
          component: Fab_Sale,
          icon: faCartShopping,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        },
        {
          id: 'saleslist_fabrics',
          label: 'Sales List',
          component: FabSaleList,
          icon: faClipboardList,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        }
      ]
    },
    {
      id: 'return',
      label: 'Return',
      icon: faBackward,
      roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics'],
      groupId: 'sales',
      position: 10,
      submenus: [
        {
          id: 'addreturn_fabrics',
          label: 'Add Return',
          component: FabReturn,
          icon: faShoppingCart,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        },
        {
          id: 'returnslist_fabrics',
          label: 'Return List',
          component: FabReturnList,
          icon: faShoppingCart,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        }
      ]
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: faPerson,
      roles: ['admin_fabrics', 'manager_fabrics'],
      groupId: 'management',
      position: 11,
      submenus: [
        {
          id: 'Employees',
          label: 'Add Employee',
          component: AddEmployee,
          icon: faUserPlus,
          roles: ['admin_fabrics', 'manager_fabrics']
        },
        {
          id: 'EmployeesList',
          label: 'Employees List',
          component: EmployeeList,
          icon: faPeopleArrows,
          roles: ['admin_fabrics', 'manager_fabrics']
        },
        {
          id: 'AddSalary',
          label: 'Add Salary',
          component: AddSalary,
          icon: faMoneyBillWave,
          roles: ['admin_fabrics', 'manager_fabrics']
        },
        {
          id: 'SalaryList',
          label: 'Salary List',
          component: SalaryList,
          icon: faMoneyBillWave,
          roles: ['admin_fabrics', 'manager_fabrics']
        }
      ]
    },
    {
      id: 'chequesrecords',
      label: 'Cheque Records',
      icon: faFileInvoice,
      roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics'],
      groupId: 'sales',
      position: 12,
      submenus: [
        {
          id: 'Cheque',
          label: 'Add Cheque',
          component: AddCheques,
          icon: faFileInvoice,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        },
        {
          id: 'chequesRecord',
          label: 'Cheques Record',
          component: ChequeList,
          icon: faListAlt,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        }
      ]
    },
    {
      id: 'transactions_fabrics',
      label: 'Transactions',
      icon: faWallet,
      roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics'],
      groupId: 'sales',
      position: 13,
      submenus: [
        {
          id: 'Tranactions',
          label: 'Add Transaction',
          component: UnifiedTransactionForm,
          icon: faMoneyBillWave,
          roles: ['admin_fabrics', 'manager_fabrics']
        },
        {
          id: 'Tranactionshistory',
          label: 'Transactions History',
          component: FabsTransactionsStatement,
          icon: faHistory,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        },
        {
          id: 'PaidTransactions',
          label: 'Paid Transactions',
          component: PaidTransactionsList,
          icon: faHistory,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        },
        {
          id: 'DuesTransactions',
          label: 'Dues Transactions',
          component: UnpaidTransactionsList,
          icon: faHistory,
          roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics']
        }
      ]
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: faGear,
      component: RootUsers,
      roles: ['admin_fabrics', 'manager_fabrics'],
      groupId: 'system',
      position: 14,
      submenus: []
    },
    {
      id: 'systemupdates',
      label: 'Notifications Center',
      icon: faBullhorn,
      component: MessageSystem,
      roles: ['admin_fabrics', 'manager_fabrics', 'user_fabrics'],
      groupId: 'system',
      position: 15,
      submenus: []
    }
  ],
  
  quickStats: [
    { id: 'todaySales', label: "Today's Sales", icon: 'faChartLine', value: '$3,200' },
    { id: 'orders', label: 'Orders', icon: 'faShoppingBag', value: 45 },
    { id: 'customers', label: 'Customers', icon: 'faUsers', value: 67 },
    { id: 'pending', label: 'Pending Orders', icon: 'faClock', value: 12 }
  ],
  
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard' },
    { key: 'Alt + C', description: 'Add Customer' },
    { key: 'Alt + L', description: 'Customer List' },
    { key: 'Alt + P', description: 'Products List' },
    { key: 'Alt + S', description: 'New Sale' },
    { key: 'Alt + O', description: 'Place Order' },
    { key: 'Alt + R', description: 'New Return' },
    { key: 'Alt + E', description: 'Add Employee' },
    { key: 'Alt + G', description: 'Employees List' },
    { key: 'Alt + T', description: 'Add Transaction' },
    { key: 'Ctrl + R / Cmd + R', description: 'Refresh Dashboard Data' },
    { key: 'Alt + H', description: 'Toggle Shortcuts Panel' }
  ]
};